<template>
  <Tabs
    v-model="value.type"
    :items="[
      { id: 'fixed', label: $t('fixedPrice') },
      { id: 'area', label: $t('areaPrice') },
      { id: 'request', label: $t('priceOnRequest') },
    ]"
    theme="border"
    class="product-pricing"
  >
    <template #before>
      <div class="tabs__tab" v-if="value.type === 'request'">
        {{ $t('priceOnRequest') }}
      </div>
      <div class="tabs__tab" v-else>
        <InputComponent
          v-model.number="value.value"
          :suffix="$store.state.enums.Region.currency"
          :mask="{
            mask: Number,
            unmask: true,
            thousandsSeparator: ' ',
          }"
          data-field="value"
          :required="isRequired('value')"
          :label="$t('costPrice') + ` (${$t('excludingVat')})`"
          :is-valid="getValidation('value').valid"
          :validation-message="getValidation('value').error"
        />
        <InputComponent
          v-model.number="value.margin.value"
          :required="isRequired('margin.value')"
          data-field="margin.value"
          :mask="{
            mask: Number,
            unmask: true,
            thousandsSeparator: ' ',
          }"
          :label="$t('priceMargin') + (value.margin.type === 'fixed' ? ` (${$t('excludingVat')})` : '')"
          :is-valid="getValidation('margin.value').valid"
          :validation-message="getValidation('margin.value').error"
        >
          <template #right>
            <ChoiceComponent
              v-model="value.margin.type"
              data-field="margin.type"
              :values="[
                { value: 'fixed', label: $store.state.enums.Region.currency },
                { value: 'percent', label: '%' },
              ]"
            />
          </template>
        </InputComponent>
        <InputComponent v-if="vatValues.length" :label="$t('valueaddedtaxLabel')" data-field="vat">
          <template #default>
            <Radio v-model.number="value.vat" :items="vatValues" />
          </template>
        </InputComponent>
        <InputComponent :label="$t('priceRounding')" data-field="rounding">
          <template #default>
            <Radio v-model="value.rounding" :items="roundingTypes" />
          </template>
        </InputComponent>

        <Price :value="value" v-bind="priceBinding" data-field="example" />
      </div>
    </template>
  </Tabs>
</template>

<script>
import { InputComponent } from 'vue-elder-input'
import { ChoiceComponent } from 'vue-elder-choice'
import Tabs from '@/components/Tabs'
import Price from './Price'
import Radio from '@kvass/radio'

export default {
  props: {
    value: Object,
    validator: Object,
    validatorPrefix: String,
    area: Number,
  },
  computed: {
    roundingTypes() {
      return [
        { value: 'none', label: this.$t('rounding:none') },
        { value: '50', label: '~50' },
        { value: '100', label: '~100' },
      ]
    },
    priceBinding() {
      if (this.$options.propsData.area) return { area: this.area }
      return {}
    },
    vatValues() {
      const vat = this.$store.state.enums.Region.vat
      if (!vat.editable) return []
      return vat.values.map(value => ({ value, label: `${value}%` }))
    },
  },
  methods: {
    getValidationField(key) {
      return this.validator.fields[[this.validatorPrefix, key].filter(Boolean).join('.')]
    },
    isRequired(key) {
      return this.getValidationField(key).rule.includes('required')
    },
    getValidation(key) {
      let field = this.getValidationField(key)
      return {
        valid: field.valid,
        error: field.error,
      }
    },
  },
  components: {
    InputComponent,
    ChoiceComponent,
    Tabs,
    Price,
    Radio,
  },
}
</script>

<style lang="scss">
.product-pricing {
  .tabs__tab {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;
  }

  [data-field='value'],
  [data-field='example'] {
    grid-column: 1 / -1;
  }

  [data-field='rounding'],
  [data-field='vat'] {
    height: auto;
    align-self: start;

    .kvass-radio {
      justify-content: space-around;
      padding: 1rem 0;
    }
  }

  [data-field='pricing'] {
    .product-price {
      margin-top: 0;
      border: none;
      background-color: #fafafa;
    }
  }

  &:has([data-field='vat']) [data-field='example'],
  &:has([data-field='vat']) [data-field='margin.value'] {
    grid-column-end: span 2;
  }

  [data-field='margin.type'] {
    gap: 0.5rem;
    flex-wrap: nowrap;
    margin: 0;

    .elder-choices__item {
      margin: 0;

      &-label {
        padding: 1rem 0rem;
        min-width: 70px;
      }
    }
  }
}
</style>
